module.exports = __webpack_public_path__ + "img/5-2.fd73e911.svg";